import { render } from "./update_vehicle.vue?vue&type=template&id=3bec79e3"
import script from "./update_vehicle.vue?vue&type=script&lang=js"
export * from "./update_vehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__